import { withInstall } from '@tav-ui/utils/with-install'
import BasicTitle from './src/basic-title.vue'
const TaBasicTitle = withInstall(BasicTitle)
export { TaBasicTitle }
export default TaBasicTitle
export * from './src/types'
